import {configureStore} from '@reduxjs/toolkit'
import loaderReducer from './loader/loaderReducer'
import breadcrumbReducer from './breadcrumb/breadcrumbReducer'

export default configureStore({
    reducer: {
        loader: loaderReducer,
        breadcrumb: breadcrumbReducer
    }
})